<script>
    import { metaInfo } from "@/core/MetaInfo";

    export default {
        name: "TestDrivePoints",
        data() {
            return {
                list: [],
            };
        },
        mounted() {
            this.getList();
        },
        methods: {
            selected(item) {
                this.$router.push({ name: "TestDrivePointEdit", params: { slug: item.id } });
            },
            getList() {
                this.$store.autoAdminApi.getTestDrivePoints().then(({ data }) => {
                    this.list = data.items;
                });
            },
        },
        metaInfo() {
            return metaInfo.getMeta("home");
        },
    };
</script>

<template>
    <section class="section">
        <div class="field">
            <b-button tag="router-link" to="/testdrive-points/new" type="is-primary" outlined>
                Добавить точку
            </b-button>
        </div>

        <h1 class="title">Список точек</h1>
        <b-table :data="list" @select="selected" hoverable>
            <b-table-column field="address" label="Улица" sortable v-slot="props">
                {{ props.row.address }}
            </b-table-column>
            <b-table-column field="city" label="Город" sortable v-slot="props">
                {{ props.row.city }}
            </b-table-column>
            <b-table-column field="id" label="Id" sortable v-slot="props">
                {{ props.row.id }}
            </b-table-column>
        </b-table>
    </section>
</template>

<style lang="scss"></style>
